import { render } from "./warehousTable.vue?vue&type=template&id=f9d42adc"
import script from "./warehousTable.vue?vue&type=script&lang=js"
export * from "./warehousTable.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__